export default {
  "readonly-text": "_readonly-text_ae6dka"
};